class Config {
  constructor () {
    this.primaryColor = [200, 200, 202]
    this.secondaryColor = [255, 255, 255]
    this.lightText = [255, 255, 255]
    this.darkText = [0, 0, 0]
    this.widgetClass = 'AppBundle\\Entity\\Macarons\\Widget'
    this.resizeGraphAreaOnEditing = true
    this.counterAlwaysRound = false
    this.colorScale = null
    this.customSchemes = []
    this.apiVersion = '2'
  }
  
  updateConfig (options) {
    Object.keys(this).forEach(k => {
      if (typeof options[k] !== 'undefined') {
        this[k] = options[k]
      }
    })
  }
}

export default new Config()



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/config.js